import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  order: {
    itemCount: 0,
    id: null,
    number: null,
    items: [],
  },
  orderFetched: false,
  orderFetching: true,
};

const syncReducers = {
  setCart: (state, { payload }) => {
    return { order: payload, orderFetched: false, orderFetching: !!payload.id };
  },
  updateCart: (state, { payload }) => {
    return { order: payload, orderFetched: true, orderFetching: false };
  },
  emptyCart: () => {
    return { ...INITIAL_STATE, orderFetching: false };
  },
  resetCart: () => {
    return INITIAL_STATE;
  },
};

const cart = createSlice({
  name: "cart",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { emptyCart, setCart, updateCart, resetCart } = cart.actions;

export default cart.reducer;
